import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

// The confirmation shared by the Coach Check-In Audit's two removals: the identity-wide rule and one
// evaluation's review.
//
// 🔴 WHY THIS EXISTS (2026-09-24). An auditor pressed the evaluation-level "Remove reconciliation"
// intending to remove the identity-wide rule; the review was deactivated and the rule stayed. Neither
// button named its scope and neither asked. So every removal now states what it removes AND what it
// leaves in place, the confirm button repeats the scope, and Cancel -- the action that changes
// nothing -- holds the initial focus, so Enter on an opened dialog is always safe.
export default function ScopedRemoveDialog({ open, title, confirmLabel, busy = false, onCancel, onConfirm, children }) {
  return (
    <Dialog open={open} onClose={busy ? undefined : onCancel} aria-labelledby="scoped-remove-title" maxWidth="sm" fullWidth>
      <DialogTitle id="scoped-remove-title">{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button autoFocus onClick={onCancel} disabled={busy}>Cancel</Button>
        <Button color="error" variant="outlined" onClick={onConfirm} disabled={busy}>{confirmLabel}</Button>
      </DialogActions>
    </Dialog>
  );
}
